import { InjectionToken } from '@angular/core';
import { EncryptionConfig } from './encryption.model';

export const EncryptionConfigService = new InjectionToken<EncryptionConfig>('EncryptionConfig');
